import * as Clipboard from 'expo-clipboard';
import truncate from 'lodash/truncate';
import { HStack, Pressable, Text } from 'native-base';
import { useMemo, useState } from 'react';
import { useWindowDimensions } from 'react-native';

import { useI18n } from 'app/providers/I18nProvider';
import { Pass } from 'app/services/GuestCenterService.types';
import { MAX_WIDTH_WEB } from 'app/theme/breakpoints';

const MAX_NAME_LENGTH = 34;
const HOLD_TIME = 4000;
export default function ReservationBarcodeItem({ pass }: { pass: Pass }) {
  const { t } = useI18n();
  const { width } = useWindowDimensions();
  const [copied, setCopied] = useState<boolean>(false);

  useMemo(() => {
    if (copied) {
      setTimeout(() => setCopied(false), HOLD_TIME);
    }
  }, [copied]);

  const { name, ticketClass, barcode } = pass;

  const direction = width > MAX_WIDTH_WEB ? 'row' : 'column';
  const space = width > MAX_WIDTH_WEB ? 1 : 0;

  const handleCopyBarcode = async () => {
    await Clipboard.setStringAsync(barcode.replaceAll(' ', ''));
    setCopied(true);
  };

  return (
    <HStack alignItems="center" justifyContent="space-between">
      <HStack direction={direction} space={space}>
        <Text fontStyle="italic">
          {truncate(name, { length: MAX_NAME_LENGTH })} ({ticketClass})
        </Text>
        <Text color="gray.400" fontStyle="italic">
          {barcode}
        </Text>
      </HStack>
      {copied ? (
        <Text color="brand.success">{t('app_leaving_copied_barcode')}</Text>
      ) : (
        <Pressable onPress={handleCopyBarcode}>
          <Text fontWeight="bold" textDecorationLine="underline">
            {t('app_leaving_copy_barcode')}
          </Text>
        </Pressable>
      )}
    </HStack>
  );
}
